import React, { Component } from 'react'
import { RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next';
import Helmet from 'react-helmet';  

import queryString from 'query-string';


class PageError extends Component {
    componentDidMount() {  
        setTimeout(() => {  
            if(document.getElementById("btRedirect") != null) {
                if (typeof window !== "undefined") {
                    window.location.replace(document.getElementById("btRedirect").href);   
                }
            }
        }, 10000)
	} 

	render() {
        if (this.props.sitecoreContext.route == null)
        {
            return <></>;
        }    

		const pageDatas = this.props.sitecoreContext.route?.fields;
        const { AccueilCaf, PageLogin } = this.props.fields.data;
        let reqParams = {};
        if (typeof window !== "undefined") {
            reqParams = queryString.parse(window.location.search);
        }
    
		return (
            <>
                <Helmet>
                    {(this.props.sitecoreContext.itemId === "9131bcd5-5e41-4590-b43d-ff683596a1ce") ?   //page Unauthorized
                        <body className="pg_no-acces" />
                    :
                        <body className="pg_404" />
                    }
                </Helmet>

                {(this.props.sitecoreContext.itemId === "9131bcd5-5e41-4590-b43d-ff683596a1ce") ? //Unauthorized
                    <>
                        <section className="section_no-acces">
                            <div className="str_container"> 
                                <div className="ctn_main">
                                    <div className="ctn_paragraph var_align-center"> 
                                        { pageDatas && <RichText tag="h2" field={pageDatas["Page Title"]} /> }
                                        { pageDatas && <RichText field={pageDatas["Page Text"]} tag="p"></RichText> }
                                        <div className="ctn_cta">
                                            <a className="obj_cta" id="btRedirect" href={AccueilCaf && AccueilCaf.url}>{this.props.t('404RetourAccueil')}</a>
                                        </div> 
                                    </div>
                                </div> 
                            </div>
                        </section>
                    </>
                :
                    <>
                        { pageDatas && <RichText tag="h2" className="obj_title" field={pageDatas["Page Title"]}/> }

                        { reqParams.code && reqParams.code.startsWith("CONVOCATION") ?
                            <p className="obj_subtitle">
                                {reqParams.code === "CONVOCATION_INACTIVE" ? 
                                    <>Convocation supprimée</>
                                : 
                                    <>Convocation invalide</>
                                }
                            </p>
                        : pageDatas &&
                            <RichText field={pageDatas["Page Text"]} tag="p"/>
                        }

                        {AccueilCaf?.url ? 
                            <div className="ctn_cta">
                                <a className="obj_cta" id="btRedirect" href={AccueilCaf && AccueilCaf.url}>{this.props.t('404RetourAccueil')}</a>
                            </div>
                        : PageLogin?.url &&
                            <div className="ctn_cta">
                                <a className="obj_cta" id="btRedirect" href={PageLogin && PageLogin.url}>{this.props.t('404RetourAccueil')}</a>
                            </div>

                        }
                    </>
                }
			</>
		)
	}
}
export default withTranslation()(withSitecoreContext()(PageError));
